import PropTypes from 'prop-types';
import React from 'react';
import { withTheme } from 'styled-components';
import { isEmpty } from 'lodash';

import Box from 'ravenjs/lib/Box';
import Col from 'ravenjs/lib/Col';
import Row from 'ravenjs/lib/Row';
import Responsive from 'ravenjs/lib/Responsive';
import { themeGet } from 'ravenjs/utils/theme';

function Toolbar(props) {
    const {
        boxProps,
        center: Center,
        left: Left,
        right: Right,
        theme,
        direction,
        backgroundColor,
        ...rest
    } = props;
    // Extract some colors from the theme for the Box.
    const boxBackgroundColor = isEmpty(backgroundColor)
        ? themeGet('palette.common.toolbar')({ theme })
        : backgroundColor;

    // Build the default Box props.
    const updatedBoxProps = {
        backgroundColor: boxBackgroundColor,
        borderColor: 'transparent',
        borderRadius: '0',
        borderWidth: '0',
        margin: '0',
        padding: '20px 15px',
        ...boxProps,
    };
    const MobileToolbar =
        Left && Right && !Left() && !Right() ? (
            <Row direction={direction} gutter={false}>
                <Col gutter={false}>{Center && <Center theme={theme} {...rest} />}</Col>
            </Row>
        ) : (
            <Row direction={direction} gutter={false}>
                <Col size={{ xs: 2 }} gutter={false}>
                    {Left && <Left theme={theme} {...rest} />}
                </Col>
                <Col size={{ xs: 8 }} gutter={false}>
                    {Center && <Center theme={theme} {...rest} />}
                </Col>
                <Col size={{ xs: 2 }} gutter={false}>
                    {Right && <Right theme={theme} {...rest} />}
                </Col>
            </Row>
        );
    const DesktopToolbar = (
        <Row direction={direction} gutter={false}>
            <Col gutter={false}>{Left && <Left theme={theme} {...rest} />}</Col>
            <Col gutter={false}>{Center && <Center theme={theme} {...rest} />}</Col>
            <Col gutter={false}>{Right && <Right theme={theme} {...rest} />}</Col>
        </Row>
    );
    return (
        <Box {...updatedBoxProps}>
            <Responsive size="md" value="less">
                {MobileToolbar}
            </Responsive>
            <Responsive size="md" value="greater">
                {DesktopToolbar}
            </Responsive>
        </Box>
    );
}

Toolbar.propTypes = {
    /**
     * Properties applied to the `Box` component.
     */
    boxProps: PropTypes.object,
    /**
     * Component to render in the `Center` part of the Toolbar.
     */
    center: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    /**
     * The children to render inside the Toolbar.
     * Usually a couple of `Rows` with `Cols` and inner components.
     */
    children: PropTypes.node,
    /**
     * Component to render in the `Left` part of the Toolbar.
     */
    left: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    /**
     * Component to render in the `Right` part of the Toolbar.
     */
    right: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    /**
     * @ignore
     */
    theme: PropTypes.object,
    direction: PropTypes.object,
    backgroundColor: PropTypes.string,
};

Toolbar.defaultProps = {
    boxProps: null,
    center: null,
    children: null,
    left: null,
    right: null,
    theme: null,
    backgroundColor: null,
    direction: { xs: 'column', md: 'row' },
};

export { Toolbar as ToolbarUnwrapped };
export default React.memo(withTheme(Toolbar));
